module.exports = __webpack_public_path__ + "static/media/SWSCRC6-31.44e6716f.mp3";